import DashboardLayout from "../../components/DashboardLayout";
import OfficerTable from "../../components/OfficerTable";

const SuperadminDashboard = () => {
  return (
    <DashboardLayout role="superadmin">
      {/* <h2>Superadmin Dashboard</h2> */}
      <OfficerTable />
    </DashboardLayout>
  );
};

export default SuperadminDashboard;
